// extracted by mini-css-extract-plugin
export default {"savedTab":"saved_savedTab__MopBB","noSavedText":"saved_noSavedText__T8rFq","emptySaveButton":"saved_emptySaveButton__Gl+4J","noSavedontainer":"saved_noSavedontainer__boc2D"};